import { PaymentSheetsPage } from '../../../sections/@payment-sheets/PaymentSheetPage';
import { PaymentSheetsPageContextProvider } from '../../../sections/@payment-sheets/context/PaymentSheetPageContext';

export const PaymentSheetsPageWrapper = () => (
  <PaymentSheetsPageContextProvider>
    <PaymentSheetsPage />
  </PaymentSheetsPageContextProvider>
);
